const mediaItems = [
  {
    title: '91精品影视功能全景展示',
    desc: '3分钟快速了解APP全部核心功能：片库浏览、智能推荐、离线下载、多端同步，带你一站式掌握所有玩法。',
    img: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20a%20clean%20video%20streaming%20app%20interface%20with%20organized%20movie%20category%20tabs%20and%20colorful%20thumbnail%20grid%2C%20placed%20on%20a%20minimal%20desk%20with%20a%20cup%20of%20coffee%2C%20warm%20morning%20sunlight%2C%20cozy%20lifestyle%20photography%20with%20soft%20shadows&width=800&height=500&seq=media-1-91movie&orientation=landscape',
    alt: '91精品影视功能展示',
    duration: '03:28',
  },
  {
    title: '新手上路：安装与使用指南',
    desc: '从下载安装到注册登录，再到找片追剧，手把手带你快速上手91精品影视APP，零基础也能轻松玩转。',
    img: 'https://readdy.ai/api/search-image?query=Clean%20flat%20lay%20photography%20of%20a%20smartphone%20showing%20a%20step-by-step%20setup%20guide%20interface%20with%20simple%20illustrations%2C%20surrounded%20by%20modern%20desk%20accessories%2C%20bright%20and%20airy%20workspace%2C%20soft%20natural%20light%20from%20window%2C%20minimalist%20aesthetic&width=800&height=500&seq=media-2-91movie&orientation=landscape',
    alt: '91精品影视使用指南',
    duration: '05:15',
  },
  {
    title: '用户真实体验分享合集',
    desc: '精选多位91精品影视资深用户的真实使用体验，听听他们为什么选择91精品影视以及最爱的功能是什么。',
    img: 'https://readdy.ai/api/search-image?query=A%20group%20of%20friends%20relaxing%20on%20a%20comfortable%20sofa%20watching%20something%20together%20on%20a%20tablet%2C%20cozy%20living%20room%20scene%20with%20warm%20ambient%20lighting%2C%20genuine%20expressions%20of%20enjoyment%2C%20lifestyle%20photography%20with%20natural%20poses%2C%20inviting%20and%20relaxed%20atmosphere&width=800&height=500&seq=media-3-91movie&orientation=landscape',
    alt: '91精品影视用户体验',
    duration: '08:42',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-screen-2xl px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            精彩视频
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            通过视频了解91精品影视的更多精彩内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 max-w-5xl mx-auto">
          {mediaItems.map((m) => (
            <div key={m.title} className="group bg-white rounded-2xl overflow-hidden border border-secondary-100 transition-all hover:border-primary-200 cursor-pointer">
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={m.img}
                  alt={m.alt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center transition-transform group-hover:scale-110">
                    <i className="ri-play-fill text-primary-600 text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 rounded text-xs bg-black/60 text-white backdrop-blur-sm whitespace-nowrap">
                  {m.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-2 leading-snug">{m.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">{m.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}